/* ELVA cookie banner.

   The banner does not load the Meta pixel itself any more. It records the
   answer with Shopify's Customer Privacy API, and the custom pixel in
   Settings > Customer events reads that and decides whether to load Meta.

   That matters because a custom pixel runs in a sandbox. It cannot see
   localStorage on the page, so a banner that only wrote to localStorage would
   leave the pixel with no way to know whether consent had been given. Writing
   the answer into Shopify's own consent state is what joins the two up.

   If the Customer Privacy API is unavailable for any reason, the banner still
   works and still remembers the answer, and the pixel simply stays off. */
(function () {
  var KEY = 'elva-consent';
  var box = document.getElementById('ckie');
  if (!box) return;

  function readLocal() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
  function writeLocal(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }

  /* ---------- Shopify's consent API ---------- */
  function withPrivacy(fn) {
    if (window.Shopify && window.Shopify.customerPrivacy) { fn(window.Shopify.customerPrivacy); return; }
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') { fn(null); return; }
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      fn(err ? null : (window.Shopify.customerPrivacy || null));
    });
  }

  function record(allowed) {
    withPrivacy(function (cp) {
      if (!cp || typeof cp.setTrackingConsent !== 'function') return;
      cp.setTrackingConsent({
        analytics: allowed,
        marketing: allowed,
        preferences: allowed,
        sale_of_data: allowed
      }, function () { /* the custom pixel picks this up on its own */ });
    });
  }

  function hide() { box.hidden = true; }
  function show() { box.hidden = false; }

  box.querySelector('[data-ckie-ok]').addEventListener('click', function () {
    writeLocal('yes'); record(true); hide();
  });
  box.querySelector('[data-ckie-no]').addEventListener('click', function () {
    writeLocal('no'); record(false); hide();
  });

  /* ---------- ask once ----------
     Shopify knows whether this visitor still needs asking, including visitors
     outside the regions where a banner is required. Its answer wins when it is
     available, and the local note is the fallback. */
  withPrivacy(function (cp) {
    if (cp && typeof cp.shouldShowBanner === 'function') {
      if (cp.shouldShowBanner()) show();
      return;
    }
    if (!readLocal()) show();
  });
})();
